import { ActionTypes } from '../constants';

const defaults = {
    currency: '$',
    iso2: 'US',
    rnDevEnv: false,
};

export interface CacheState {
    currency: string;
    iso2: String;
    rnDevEnv: boolean;
}

export interface ActionType {
    type: string;
    payload: any;
}

export default (state: CacheState = defaults, action: ActionType) => {
    switch (action.type) {
        case ActionTypes.UPDATE_CURRENCY: {
            return { ...state, ...action.payload };
        }
        default:
            return { ...state };
    }
};
